module.exports = __webpack_public_path__ + "img/Gift_Guide-pace.5660e7f.jpg";